import React, { useEffect, useState } from 'react';
import '../../assets/styles/Home.css';
import '../../assets/styles/SectionBand.css';
import { useLanguage } from '../../assets/js/LanguageContext';
import SealCard from '../common/SealCard';
import SectionEyebrow from '../common/SectionEyebrow';

const HomeAchievements = () => {
  const { t, language } = useLanguage();
  const [seals, setSeals] = useState([]);
  const [loaded, setLoaded] = useState(false);
  // Se abre con el raton por CSS; este estado es para el clic, que es lo que
  // hace que funcione en tactil, donde no hay hover.
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const apiUrl = process.env.REACT_APP_API_URL || '';
    fetch(`${apiUrl}/api/home-seals?lang=${language}`)
      .then((res) => (res.ok ? res.json() : []))
      .then((data) => {
        if (cancelled) return;
        setSeals(Array.isArray(data) ? data : []);
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setSeals([]);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
    // Los sellos se piden otra vez al cambiar de idioma
  }, [language]);

  if (!loaded || seals.length === 0) return null;

  return (
    <section className="awards" aria-label={t('home_seals_eyebrow') || 'Reconocimientos'}>
      <div className="awards__inner">
        <div className="awards__head">
          <SectionEyebrow>{t('home_seals_eyebrow')}</SectionEyebrow>
          <h2 className="section-band__lead awards__heading">{t('home_seals_heading')}</h2>
        </div>

        <div className="awards__grid">
          {seals.map((seal) => (
            <SealCard
              key={seal.id}
              seal={seal}
              open={openId === seal.id}
              onToggle={() => setOpenId(openId === seal.id ? null : seal.id)}
              detailId={`award-detail-${seal.id}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default HomeAchievements;
